import { createContext, useContext } from 'react';

type TContextApi = () => void;

export const ctx = createContext<TContextApi | null>(null);

export const useCloseMenu = () => orDie(useContext(ctx));
